import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { SubactivityBuilder } from '../../models/builders/subactivity.builder';
import { UserSubactivity } from '../../models/user-subactivity';
import { UserSubactivityBuilder } from '../../models/builders/user-subactivity.builder';

const userSubactivityBody = (userSubactivity: UserSubactivity) => ({
  name: userSubactivity.name,
  userActivityHash: userSubactivity.userActivity,
});

@Injectable()

export class UserSubactivityApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }userSubactivities`;
  }

  createUserSubactivity(userSubactivity) {
    return this.httpClient.post(this.apiUrl, userSubactivityBody(userSubactivity)).pipe(map(UserSubactivityBuilder.fromJson));
  }

  deleteUserSubactivity(userSubactivity: UserSubactivity) {
    return this.httpClient.delete(`${ this.apiUrl }/${ userSubactivity.hash }`);
  }

  getUserSubactivities() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(UserSubactivityBuilder.fromList));
  }

  getSearchUserSubactivities(search: string) {
    const params = new HttpParams().append('search', search);
    return this.httpClient.get(`${ this.apiUrl }/search`, { params })
    .pipe(
      map(UserSubactivityBuilder.fromList)
    );
  }

  getSearchUserSubactivitiesByUser(user: string, search: string) {
    const params = new HttpParams().append('user', user).append('search', search);
    return this.httpClient.get(`${ this.apiUrl }/searchByUser`, { params })
    .pipe(
      map(UserSubactivityBuilder.fromList)
    );
  }

  getUserSubactivity(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(SubactivityBuilder.fromJson));
  }

  updateUserSubactivity(userSubactivity: UserSubactivity) {
    return this.httpClient.put(`${ this.apiUrl }/${ userSubactivity.hash }`, userSubactivityBody(userSubactivity));
  }

  getUserSubactivitiesByUser(user: string) {
    const params = new HttpParams().append('user', user);
    return this.httpClient.get(`${ this.apiUrl }/user`, { params })
    .pipe(
      map(UserSubactivityBuilder.fromList)
    );
  }

  getUserSubactivitiesByValidation(hash: string) {
    const params = new HttpParams().append('validation', hash);
    return this.httpClient.get(`${ this.apiUrl }/validation`, { params })
    .pipe(
      map(UserSubactivityBuilder.fromList)
    );
  }

  getUserSubactivitiesByActivity(activity: string) {
    const params = new HttpParams().append('activity', activity);
    return this.httpClient.get(`${ this.apiUrl }/activity`, { params })
    .pipe(
      map(UserSubactivityBuilder.fromList)
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/user-subactivity-api.service.ts